import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { Dialog } from "component/shared/dialog";
import { Market } from "model/market";
import { styles } from "./styles";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	market: Market;
	deleteMarketDialogIsOpen: boolean;
	hideDeleteMarketDialog: Function;
	deleteMarket: Function;
}

const component = (props: Props) => {
	const {
		market,
		classes = {},
		deleteMarket,
		deleteMarketDialogIsOpen,
		hideDeleteMarketDialog,
	} = props;

	return (
		<Dialog
			open={deleteMarketDialogIsOpen}
			onClose={() => hideDeleteMarketDialog()}
		>
			<Mui.DialogTitle>Delete Market</Mui.DialogTitle>
			<Mui.DialogContent className={classes.dialogContent}>
				<Mui.DialogContentText>
					{`Are you sure you want to delete ${market.name}?`}
				</Mui.DialogContentText>
			</Mui.DialogContent>
			<Mui.DialogActions className={classes.dialogActions}>
				<Mui.Button onClick={() => hideDeleteMarketDialog()} variant="outlined" color={"primary"}>
					No
				</Mui.Button>
				<Mui.Button
					onClick={() => deleteMarket()}
					variant="contained"
					color={"primary"}
				>
					Yes
				</Mui.Button>
			</Mui.DialogActions>
		</Dialog>
	);
};

export const DeleteMarketDialog = withStyles(component, styles);
